import { render, staticRenderFns } from "./CharacterBuilderClassNew.vue?vue&type=template&id=4b7206b7&lang=pug&"
import script from "./CharacterBuilderClassNew.vue?vue&type=script&lang=ts&"
export * from "./CharacterBuilderClassNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
